import { axiosInstanceVirtualCard } from "../axios";
import {
  PortMappingCreate,
  PortMappingCreations,
  RequestResponse
} from "../types";

export const getPortMapping = async (id: number): Promise<RequestResponse> => {
  try {
    const response = await axiosInstanceVirtualCard.get(
      `/api/v1/port-mappings/${id}`
    );
    return {
      error: false,
      data: response.data.data
    };
  } catch (err: any) {
    console.error("Unable to fetch port mapping: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch port mapping: Internal server error");
      return {
        error: true,
        message: "Unable to fetch port mapping: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: null
    };
  }
};

export const getPortMappings: (
  pageNumber: number,
  pageSize: number,
  issuerCode?: string
) => Promise<
  RequestResponse<{ records: PortMappingCreations[]; total: number }>
> = async (pageNumber, pageSize, issuerCode) => {
  try {
    const response = await axiosInstanceVirtualCard.get(
      "/api/v1/port-mappings",
      {
        params: {
          page_num: pageNumber,
          page_size: pageSize,
          search_query: issuerCode
        }
      }
    );

    return {
      error: false,
      data: {
        records: response.data.data.content,
        total: response.data.data.count
      }
    };
  } catch (err: any) {
    console.error("Unable to fetch port mappings: ", { err });

    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to fetch port mappings: Internal server error");
      return {
        error: true,
        message: "Unable to fetch port mappings: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response.data?.message || err.message || err,
      data: null
    };
  }
};

export const deletePortMapping = async (
  id: number
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.delete(`/api/v1/port-mappings/${id}`);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to delete port mapping: ", err);

    let errorMessage = err.response?.data.responseMessage || err.message || err;
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to delete port mapping: Internal server error");
      errorMessage = "Unable to delete port mapping: Internal server error";
    } else if (
      errorMessage.includes("Failed. Do deactivate port mapping first")
    ) {
      errorMessage = "Kindly deactivate port mapping first";
    }
    return {
      error: true,
      message: errorMessage,
      data: err.response?.data || null
    };
  }
};

export const activatePortMapping = async (
  id: number
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.post(`/api/v1/port-mappings/${id}/activate`);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to activate port mapping: ", err);

    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to activate port maping: Internal server error");
      return {
        error: true,
        message: "Unable to activate port mapping: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const deactivatePortMapping = async (
  id: number
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.delete(
      `/api/v1/port-mappings/${id}/deactivate`
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to deactivate port mapping: ", err);

    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to deactivate port mapping: Internal server error");
      return {
        error: true,
        message: "Unable to deactivate port mapping: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};

export const updatePortMapping = async (
  id: number,
  payload: PortMappingCreate
): Promise<RequestResponse> => {
  try {
    const updatedPayload = {
      id,
      ...payload
    };
    await axiosInstanceVirtualCard.put(
      `/api/v1/port-mappings/${id}`,
      updatedPayload
    );
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to update port mapping: ", err);
    let errorMessage = err.response?.data.responseMessage || err.message || err;
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to update port mapping: Internal server error");
      errorMessage = "Unable to update port mapping: Internal server error";
    } else if (
      errorMessage.includes("Failed. Do deactivate port mapping first")
    ) {
      errorMessage = "Kindly deactivate port mapping first";
    }
    return {
      error: true,
      message: errorMessage,
      data: err.response?.data || null
    };
  }
};

export const createPortMapping = async (
  payload: PortMappingCreate
): Promise<RequestResponse> => {
  try {
    await axiosInstanceVirtualCard.post(`/api/v1/port-mappings`, payload);
    return {
      error: false,
      data: null
    };
  } catch (err: any) {
    console.error("Unable to create port mapping: ", err);
    if (
      err.response?.status === 500 &&
      err.response?.data.code.toLowerCase() === "Internal_server_error"
    ) {
      console.error("Unable to create port mapping: Internal server error");
      return {
        error: true,
        message: "Unable to create port mapping: Internal server error",
        data: null
      };
    }
    return {
      error: true,
      message: err.response?.data.responseMessage || err.message || err,
      data: err.response?.data || null
    };
  }
};
